import { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { trackOnboardingRoute } from "../utils/onboardingTracker";

/**
 * Component that tracks onboarding page views on route changes
 * This should be placed at the router level to avoid duplicate events
 */
const OnboardingTracker = ({ location }) => {
  useEffect(() => {
    // Track the current route when component mounts or location changes
    trackOnboardingRoute(location.pathname);
  }, [location.pathname]);

  // This component doesn't render anything
  return null;
};

export default withRouter(OnboardingTracker);
